import React, { Fragment, useState } from 'react'
import {
  Checkbox,
  useTheme,
  MenuItem,
  Grid2,
  Box,
} from '@mui/material'
import GridCell from './GridCell'
import AnchorMenu from './utility/AnchorMenu'
import ItemFunctionDisplay from './utility/itemFunctionDisplay'
import Text from '../genericComponents/Text'

const GridRow = ({
  item,
  onClick,
  multiSelectedItemOptions,
  getSelectedItemOptions,
  gridHeight,
  columns,  
  handleSetSelectedItems,
  selectedItems,
  getItemOptions
}) => {  
  const [activeHover, setActiveHover] = useState(false)
  const [anchorEl, setAnchorEl] = useState()
  const theme = useTheme()

  const handleClick = (event) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <Fragment>
      <Box sx={{display:{xs:"none", sm:"block"}}}>
        <Grid2
          onMouseMoveCapture={() => setActiveHover(true)}
          onMouseLeave={() => setActiveHover(false)}          
          container
          style={{
            alignItems: 'center',
            cursor: onClick && 'pointer',
            height:gridHeight,
            backgroundColor: selectedItems.find((x) => x === item.id)
              ? theme.palette.mode === 'dark' ?"#363636": "#e6e6e6"
              : activeHover &&
              (theme.palette.mode === 'dark' ?"#363636": "#e6e6e6"),
            borderBottom: `1px solid ${theme.palette.mode === 'dark' 
              ? theme.palette.primary.dark 
              : theme.palette.primary.light
            }`,                        
          }}
        >
          <Grid2 onClick={()=>handleSetSelectedItems(item)} style={{ width: theme.spacing(3) }}>
            {(getSelectedItemOptions&&getSelectedItemOptions(selectedItems[0])||multiSelectedItemOptions) &&
              (selectedItems.find((x) => x.id === item.id) || activeHover) && (
                <Checkbox color='secondary' checked={selectedItems.find((x) => x.id === item.id) ? true : false} />
              )}
          </Grid2>
          {columns
            .filter((x) => x.propertyName !== 'id')
            .map((x, i) => (
              <div onClick={onClick} style={{height:gridHeight,alignContent:"center", flex: 1 }} key={i}>
                <GridCell column={x} item={item} />
              </div>
            ))}
          {ItemFunctionDisplay(getItemOptions, item, handleClick)}
          <AnchorMenu
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            onClose={e => {handleClose(); e.stopPropagation()}}
          >
            {getItemOptions &&
              getItemOptions(item).map((x, i) => (
                <MenuItem
                  onClick={e => {
                    e.stopPropagation()
                    x.onClick(item)
                    handleClose()
                  }}
                  key={i}>
                  <Text text={x.title} />
                </MenuItem>
              ))}
          </AnchorMenu>
        </Grid2>
      </Box>      
    </Fragment>
  )
}

export default GridRow
